// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HLem","top":"styles_top__LGjkv","left":"styles_left__1VIQd","description":"styles_description__1GABM"};